__turbopack_context__.v({
  "badge": "MarketplaceLoadCardV3-module-scss-module__wNFzLa__badge",
  "badgeIcon": "MarketplaceLoadCardV3-module-scss-module__wNFzLa__badgeIcon",
  "badges": "MarketplaceLoadCardV3-module-scss-module__wNFzLa__badges",
  "bestPriceBadge": "MarketplaceLoadCardV3-module-scss-module__wNFzLa__bestPriceBadge",
  "bidNowBtn": "MarketplaceLoadCardV3-module-scss-module__wNFzLa__bidNowBtn",
  "card": "MarketplaceLoadCardV3-module-scss-module__wNFzLa__card",
  "detailBlock": "MarketplaceLoadCardV3-module-scss-module__wNFzLa__detailBlock",
  "detailLabel": "MarketplaceLoadCardV3-module-scss-module__wNFzLa__detailLabel",
  "detailValue": "MarketplaceLoadCardV3-module-scss-module__wNFzLa__detailValue",
  "detailsSection": "MarketplaceLoadCardV3-module-scss-module__wNFzLa__detailsSection",
  "footer": "MarketplaceLoadCardV3-module-scss-module__wNFzLa__footer",
  "header": "MarketplaceLoadCardV3-module-scss-module__wNFzLa__header",
  "headerContent": "MarketplaceLoadCardV3-module-scss-module__wNFzLa__headerContent",
  "hpv2Blink": "MarketplaceLoadCardV3-module-scss-module__wNFzLa__hpv2Blink",
  "hpv2DemoBounce": "MarketplaceLoadCardV3-module-scss-module__wNFzLa__hpv2DemoBounce",
  "hpv2DemoFadeIn": "MarketplaceLoadCardV3-module-scss-module__wNFzLa__hpv2DemoFadeIn",
  "hpv2DemoProgress": "MarketplaceLoadCardV3-module-scss-module__wNFzLa__hpv2DemoProgress",
  "hpv2DemoScaleIn": "MarketplaceLoadCardV3-module-scss-module__wNFzLa__hpv2DemoScaleIn",
  "hpv2DemoSlideIn": "MarketplaceLoadCardV3-module-scss-module__wNFzLa__hpv2DemoSlideIn",
  "hpv2FadeLeft": "MarketplaceLoadCardV3-module-scss-module__wNFzLa__hpv2FadeLeft",
  "hpv2FadeRight": "MarketplaceLoadCardV3-module-scss-module__wNFzLa__hpv2FadeRight",
  "hpv2FadeUp": "MarketplaceLoadCardV3-module-scss-module__wNFzLa__hpv2FadeUp",
  "hpv2FloatA": "MarketplaceLoadCardV3-module-scss-module__wNFzLa__hpv2FloatA",
  "hpv2FloatB": "MarketplaceLoadCardV3-module-scss-module__wNFzLa__hpv2FloatB",
  "hpv2HeroFadeIn": "MarketplaceLoadCardV3-module-scss-module__wNFzLa__hpv2HeroFadeIn",
  "hpv2HeroFadeInOpacity": "MarketplaceLoadCardV3-module-scss-module__wNFzLa__hpv2HeroFadeInOpacity",
  "hpv2HeroSlideIn": "MarketplaceLoadCardV3-module-scss-module__wNFzLa__hpv2HeroSlideIn",
  "hpv2PriceShimmer": "MarketplaceLoadCardV3-module-scss-module__wNFzLa__hpv2PriceShimmer",
  "hpv2PulseDot": "MarketplaceLoadCardV3-module-scss-module__wNFzLa__hpv2PulseDot",
  "hpv2ScaleUp": "MarketplaceLoadCardV3-module-scss-module__wNFzLa__hpv2ScaleUp",
  "iconWrapper": "MarketplaceLoadCardV3-module-scss-module__wNFzLa__iconWrapper",
  "priceLabel": "MarketplaceLoadCardV3-module-scss-module__wNFzLa__priceLabel",
  "priceRow": "MarketplaceLoadCardV3-module-scss-module__wNFzLa__priceRow",
  "priceSection": "MarketplaceLoadCardV3-module-scss-module__wNFzLa__priceSection",
  "priceSubtext": "MarketplaceLoadCardV3-module-scss-module__wNFzLa__priceSubtext",
  "priceSubtextAdvance": "MarketplaceLoadCardV3-module-scss-module__wNFzLa__priceSubtextAdvance",
  "priceSubtextDot": "MarketplaceLoadCardV3-module-scss-module__wNFzLa__priceSubtextDot",
  "priceSubtextRate": "MarketplaceLoadCardV3-module-scss-module__wNFzLa__priceSubtextRate",
  "priceValue": "MarketplaceLoadCardV3-module-scss-module__wNFzLa__priceValue",
  "shareBtn": "MarketplaceLoadCardV3-module-scss-module__wNFzLa__shareBtn",
  "subtitle": "MarketplaceLoadCardV3-module-scss-module__wNFzLa__subtitle",
  "title": "MarketplaceLoadCardV3-module-scss-module__wNFzLa__title",
  "topRouteBadge": "MarketplaceLoadCardV3-module-scss-module__wNFzLa__topRouteBadge",
  "topUserBadge": "MarketplaceLoadCardV3-module-scss-module__wNFzLa__topUserBadge",
});
